// extracted by mini-css-extract-plugin
export default {"note":"note_note__dSNq-"};